<ng-container *ngIf="isMobile">
  <ng-container *ngTemplateOutlet="mobileView"></ng-container>
</ng-container>

<!-- MOBILE -->
<ng-template #mobileView>
  <ng-container *ngIf="position === 'bottom'; else mobileTop">
    <ng-container *ngTemplateOutlet="mobileBottom"></ng-container>
  </ng-container>
</ng-template>

<!-- MOBILE TOP -->
<ng-template #mobileTop>
  <app-topbar></app-topbar>
</ng-template>

<!-- MOBILE BOTTOM -->
<ng-template #mobileBottom>
  <nav
    fxLayout="row"
    fxFlex="auto"
    class="navigation-bar bot-bar"
    *ngIf="!isCandidate"
  >
    <ul fxLayout="row" fxFlex="auto" fxLayoutAlign="space-around center">
      <li *ngFor="let item of mobileMainItems">
        <a
          routerLink="{{ item.path }}"
          routerLinkActive="active"
          [ngStyle]="{ color: color || defaultColor }"
        >
          <span fxLayout="column" fxLayoutAlign="start center">
            <mat-icon>{{ item.icon }}</mat-icon>
            <span class="link-label">{{ item.label }}</span>
          </span>
        </a>
      </li>
      <li [matMenuTriggerFor]="remainingLinksMenu">
        <a>
          <span fxLayout="column" fxLayoutAlign="start center">
            <mat-icon>more_horiz</mat-icon>
            <span class="link-label">More</span>
          </span>
        </a>
      </li>
      <mat-menu #remainingLinksMenu="matMenu">
        <a
          *ngFor="let item of mobileRemainingItems"
          routerLink="{{ item.path }}"
          routerLinkActive="active"
          [ngStyle]="{ color: color || defaultColor }"
          mat-menu-item
          class="menu-item"
        >
          <mat-icon>{{ item.icon }}</mat-icon>
          <span>{{ item.label }}</span>
        </a>
      </mat-menu>
    </ul>
  </nav>
</ng-template>

<!-- PARTIALS -->
<!-- AVATAR -->
<ng-template #avatarTemplate let-size="size">
  <app-avatar
    fxLayout="row"
    fxFlexAlign="center"
    [image]="avatar"
    [size]="size"
    class="clickeable"
    [matMenuTriggerFor]="userMenu"
  ></app-avatar>
</ng-template>

<mat-menu #userMenu="matMenu">
  <button mat-menu-item (click)="selectApp()" *ngIf="access">
    <mat-icon>view_stream</mat-icon>
    <span>Select Site</span>
  </button>
  <button mat-menu-item [routerLink]="'/settings'">
    <mat-icon>settings</mat-icon>
    <span>Settings</span>
  </button>
  <button mat-menu-item (click)="logout()">
    <mat-icon>exit_to_app</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>

<!-- LOGO -->
<ng-template #logoTemplate>
  <img
    [src]="logo || '../../../assets/images/logos/logo-lss-vertical-color.png'"
    class="logo"
  />
</ng-template>

<!-- Version -->
<ng-template #versionTemplate>
  <div class="version-panel">
    <span class="version-text">Version 1.0.0</span>
  </div>
</ng-template>
